import { OwnershipNature } from 'src/types/governance.types';

export const OWNERSHIP_MANTINE_COLOR: Record<OwnershipNature, string> = {
  [OwnershipNature.PLEINE_PROPRIETE]: 'green',
  [OwnershipNature.USUFRUIT]: 'orange',
  [OwnershipNature.NUE_PROPRIETE]: 'grape',
};

export const OWNERSHIP_CSS_VAR: Record<OwnershipNature, string> = {
  [OwnershipNature.PLEINE_PROPRIETE]: 'var(--sh-ownership-pp)',
  [OwnershipNature.USUFRUIT]: 'var(--sh-ownership-us)',
  [OwnershipNature.NUE_PROPRIETE]: 'var(--sh-ownership-np)',
};

export const OWNERSHIP_SHORT_LABEL: Record<OwnershipNature, string> = {
  [OwnershipNature.PLEINE_PROPRIETE]: 'PP',
  [OwnershipNature.USUFRUIT]: 'US',
  [OwnershipNature.NUE_PROPRIETE]: 'NP',
};

export const OWNERSHIP_FULL_LABEL: Record<OwnershipNature, string> = {
  [OwnershipNature.PLEINE_PROPRIETE]: 'Pleine propriété',
  [OwnershipNature.USUFRUIT]: 'Usufruit',
  [OwnershipNature.NUE_PROPRIETE]: 'Nue-propriété',
};
